import LatestInstructionGuidelineContainer from "./DocumentManagement";
export default LatestInstructionGuidelineContainer;
